module.exports = {
	"*/v*/*__errors__*": {
		"GET": {
			"errors": {
				"code": "SERVICE_UNAVAILABLE",
				"message": "Our service is temprary unavailable."
			}
		}
	},
	"*/v*/*/banner": {
		"GET": {
			"pageUrl": "http://travel.rakuten.com.tw/point/",
			"imageWideUrl": "http://img.travel.rakuten.co.jp/m17n/share/img/across/tw_point_20160126.png",
			"imageNarrowUrl": "http://img.travel.rakuten.co.jp/m17n/share/img/across/tw_point_20160126_s.png",
			"name": "預訂樂天旅遊酒店，獲得樂天超級點數！"
		}
	},
	"*/v*/*/breadcrumbs?*ids=Japan*Tokyo_Prefecture*Tokyo*Shinagawa*19455": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
					"text": "Tokyo Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo",
					"text": "Tokyo"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo-Shinagawa",
					"text": "Shinagawa"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa/19455",
					"text": "Shinagawa Prince hotel"
				}
			]
		}
	},
	"*/v*/*/breadcrumbs?*ids=Japan*Tokyo_Prefecture*Tokyo*Shinagawa": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
					"text": "Tokyo Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo",
					"text": "Tokyo"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo-Shinagawa",
					"text": "Shinagawa"
				}
			]
		}
	},
	"*/v*/*/breadcrumbs?*ids=Japan*Tokyo_Prefecture*Tokyo": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
					"text": "Tokyo Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo",
					"text": "Tokyo"
				}
			]
		}
	},
	"*/v*/*/breadcrumbs?*ids=Japan*Tokyo_Prefecture": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
					"text": "Tokyo Prefecture"
				}
			]
		}
	},
	"*/v*/*/breadcrumbs?*ids=Japan": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				}
			]
		}
	},
	"*/v*/*/breadcrumbs": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://travel.rakuten.com/",
					"text": "Home"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan",
					"text": "Japan"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
					"text": "Tokyo Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo",
					"text": "Tokyo"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture-Tokyo-Shinagawa",
					"text": "Shinagawa"
				}
			]
		}
	},
	"*/v*/*/currencies": {
		"GET": {
			"items": [
				{
					"id": "USD",
					"symbol": "US$",
					"name": "U.S. Dollar"
				},
				{
					"id": "USD",
					"symbol": "US$",
					"name": "U.S. Dollar"
				},
				{
					"id": "EUR",
					"symbol": "€",
					"name": "Euro"
				},
				{
					"id": "TWD",
					"symbol": "TWD",
					"name": "New Taiwan Dollar"
				},
				{
					"id": "CNY",
					"symbol": "CNY",
					"name": "Chinese Yuan"
				},
				{
					"id": "HKD",
					"symbol": "HKD",
					"name": "Hong Kong Dollar"
				},
				{
					"id": "KRW",
					"symbol": "₩",
					"name": "Korean Won"
				},
				{
					"id": "THB",
					"symbol": "THB",
					"name": "Thai Baht"
				},
				{
					"id": "SGD",
					"symbol": "S$",
					"name": "Singaporean Dollar"
				},
				{
					"id": "MYR",
					"symbol": "MYR",
					"name": "Malaysiuan Ringgit"
				},
				{
					"id": "IDR",
					"symbol": "Rp",
					"name": "Indonesian Rupiah"
				},
				{
					"id": "INR",
					"symbol": "Rs.",
					"name": "Indian Rupee"
				},
				{
					"id": "AUD",
					"symbol": "AUD",
					"name": "Australlian Dollar"
				},
				{
					"id": "CAD",
					"symbol": "C$",
					"name": "Canadian Dollar"
				},
				{
					"id": "GBP",
					"symbol": "￡",
					"name": "Pound Sterling"
				},
				{
					"id": "CHF",
					"symbol": "CHF",
					"name": "Swiss Franc"
				},
				{
					"id": "JPY",
					"symbol": "JPY",
					"name": "Japanese Yen"
				}
			]
		}
	},
	"*/v*/*/explanations": {
		"GET": {
			"title": "Why travel with Rakuten?",
			"items": [
				{
					"name": "More hotels",
					"description": "Choose from online selection of more than <strong>18,000</strong> hotels and ryokan in Japan",
					"iconName": "icon-hotel-large"
				},
				{
					"name": "More deals",
					"description": "Get domestic rates and exclusive discounts from Japan’s largest online travel agency",
					"iconName": "icon-deal-large"
				},
				{
					"name": "More value",
					"description": "Customize your trip with accommodation plans",
					"iconName": "icon-value-large"
				}
			]
		}
	},
	"*/v*/*/hotels?*price*": {
		"GET": {
			"offset": 0,
			"limit": 20,
			"total": 403,
			"items": [],
			"filters": [
				{
					"id": "rate-5",
					"name": "5 Stars",
					"count": 0
				},
				{
					"id": "rate-4",
					"name": "4 Stars",
					"count": 0
				},
				{
					"id": "rate-3",
					"name": "3 Stars",
					"count": 0
				},
				{
					"id": "rate-2",
					"name": "2 Stars",
					"count": 0
				},
				{
					"id": "rate-1",
					"name": "1 Star",
					"count": 0
				},
				{
					"id": "hotel-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "hotel-creditcard",
					"name": "Credit cards accepted",
					"count": 0
				},
				{
					"id": "hotel-shuttle",
					"name": "Shuttle service available",
					"count": 0
				},
				{
					"id": "hotel-wheelchair",
					"name": "Wheelchair-accessible",
					"count": 0
				},
				{
					"id": "room-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "room-nonsmoking",
					"name": "Non-smoking",
					"count": 0
				},
				{
					"id": "room-smoking",
					"name": "Smoking",
					"count": 0
				},
				{
					"id": "room-washlet",
					"name": "Toilet with washlet",
					"count": 0
				},
				{
					"id": "meal-breakfast",
					"name": "Breakfast includes",
					"count": 0
				},
				{
					"id": "meal-dinner",
					"name": "Dinner includes",
					"count": 0
				}
			],
			"priceRange": {
				"min": 0,
				"max": 1000000
			}
		}
	},
	"*/v*/*/hotels?*rooms=2*": {
		"GET": {
			"errors": [
				{
					"fields": "destination",
					"code": "VALIDATION_ERROR",
					"message": "Please enter your destination"
				},
				{
					"fields": "checkin",
					"code": "VALIDATION_ERROR",
					"message": "Please enter your check-in date"
				},
				{
					"fields": "checkout",
					"code": "VALIDATION_ERROR",
					"message": "Please enter your check-out date"
				}
			]
		}
	},
	"*/v*/*/hotels?*rooms=3*": {
		"GET": {
			"offset": 0,
			"limit": 20,
			"total": 0,
			"items": []
		}
	},
	"*/v*/*/hotels?*offset=20*": {
		"GET": {
			"offset": 20,
			"limit": 20,
			"total": 403,
			"items": [
				{
					"id": "19455",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						}
					],
					"latlng": "35.675219,139.763162",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "14677",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					],
					"latlng": "35.6800514,139.7674333",
					"lead": "per night per person",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "82345",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						}
					],
					"latlng": "35.679752,139.7743006",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "52456",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "3570",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg"
						}
					],
					"latlng": "35.6768865,139.7739755",
					"plans": [],
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				}
			],
			"filters": [
				{
					"id": "rate-5",
					"name": "5 Stars",
					"count": 0
				},
				{
					"id": "rate-4",
					"name": "4 Stars",
					"count": 0
				},
				{
					"id": "rate-3",
					"name": "3 Stars",
					"count": 0
				},
				{
					"id": "rate-2",
					"name": "2 Stars",
					"count": 0
				},
				{
					"id": "rate-1",
					"name": "1 Star",
					"count": 0
				},
				{
					"id": "hotel-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "hotel-creditcard",
					"name": "Credit cards accepted",
					"count": 68
				},
				{
					"id": "hotel-shuttle",
					"name": "Shuttle service available",
					"count": 54
				},
				{
					"id": "hotel-wheelchair",
					"name": "Wheelchair-accessible",
					"count": 0
				},
				{
					"id": "room-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "room-nonsmoking",
					"name": "Non-smoking",
					"count": 68
				},
				{
					"id": "room-smoking",
					"name": "Smoking",
					"count": 54
				},
				{
					"id": "room-washlet",
					"name": "Toilet with washlet",
					"count": 0
				},
				{
					"id": "meal-breakfast",
					"name": "Breakfast includes",
					"count": 54
				},
				{
					"id": "meal-dinner",
					"name": "Dinner includes",
					"count": 0
				}
			],
			"priceRange": {
				"min": 85.5,
				"max": 1000000
			}
		}
	},
	"*/v*/*/hotels?*offset=380*": {
		"GET": {
			"offset": 380,
			"limit": 20,
			"total": 403,
			"items": [
				{
					"id": "14677",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					],
					"latlng": "35.675219,139.763162",
					"lead": "per night per person",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "19455",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						}
					],
					"latlng": "35.6800514,139.7674333",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "82345",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						}
					],
					"latlng": "35.679752,139.7743006",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "52456",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "3570",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg"
						}
					],
					"latlng": "35.6768865,139.7739755",
					"plans": [],
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				}
			],
			"filters": [
				{
					"id": "rate-5",
					"name": "5 Stars",
					"count": 0
				},
				{
					"id": "rate-4",
					"name": "4 Stars",
					"count": 0
				},
				{
					"id": "rate-3",
					"name": "3 Stars",
					"count": 0
				},
				{
					"id": "rate-2",
					"name": "2 Stars",
					"count": 0
				},
				{
					"id": "rate-1",
					"name": "1 Star",
					"count": 0
				},
				{
					"id": "hotel-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "hotel-creditcard",
					"name": "Credit cards accepted",
					"count": 68
				},
				{
					"id": "hotel-shuttle",
					"name": "Shuttle service available",
					"count": 54
				},
				{
					"id": "hotel-wheelchair",
					"name": "Wheelchair-accessible",
					"count": 0
				},
				{
					"id": "room-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "room-nonsmoking",
					"name": "Non-smoking",
					"count": 68
				},
				{
					"id": "room-smoking",
					"name": "Smoking",
					"count": 54
				},
				{
					"id": "room-washlet",
					"name": "Toilet with washlet",
					"count": 0
				},
				{
					"id": "meal-breakfast",
					"name": "Breakfast includes",
					"count": 54
				},
				{
					"id": "meal-dinner",
					"name": "Dinner includes",
					"count": 0
				}
			],
			"priceRange": {
				"min": 85.5,
				"max": 1000000
			}
		}
	},
	"*/v*/*/hotels?*offset=400*": {
		"GET": {
			"offset": 400,
			"limit": 20,
			"total": 403,
			"items": [
				{
					"id": "19455",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						}
					],
					"latlng": "35.6768865,139.7739755",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "82345",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						}
					],
					"latlng": "35.679752,139.7743006",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "14677",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					],
					"latlng": "35.6800514,139.7674333",
					"lead": "per night per person",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				}
			],
			"filters": [
				{
					"id": "rate-5",
					"name": "5 Stars",
					"count": 0
				},
				{
					"id": "rate-4",
					"name": "4 Stars",
					"count": 0
				},
				{
					"id": "rate-3",
					"name": "3 Stars",
					"count": 0
				},
				{
					"id": "rate-2",
					"name": "2 Stars",
					"count": 0
				},
				{
					"id": "rate-1",
					"name": "1 Star",
					"count": 0
				},
				{
					"id": "hotel-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "hotel-creditcard",
					"name": "Credit cards accepted",
					"count": 68
				},
				{
					"id": "hotel-shuttle",
					"name": "Shuttle service available",
					"count": 54
				},
				{
					"id": "hotel-wheelchair",
					"name": "Wheelchair-accessible",
					"count": 0
				},
				{
					"id": "room-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "room-nonsmoking",
					"name": "Non-smoking",
					"count": 68
				},
				{
					"id": "room-smoking",
					"name": "Smoking",
					"count": 54
				},
				{
					"id": "room-washlet",
					"name": "Toilet with washlet",
					"count": 0
				},
				{
					"id": "meal-breakfast",
					"name": "Breakfast includes",
					"count": 54
				},
				{
					"id": "meal-dinner",
					"name": "Dinner includes",
					"count": 0
				}
			],
			"priceRange": {
				"min": 85.5,
				"max": 1000000
			}
		}
	},
	"*/v*/*/hotels?*": {
		"GET": {
			"offset": 0,
			"limit": 20,
			"total": 403,
			"items": [
				{
					"id": "19455",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/29412/29412_rob.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/origin/355cd97014a4da77a78ac2fe2a2e45f4d115bad8.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/origin/355cd97014a4da77a78ac2fe2a2e45f4d115bad8.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/GmUFsE.jpeg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/GmUFsE.jpeg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/dlG4kI.jpeg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/dlG4kI.jpeg"
						},
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/image_up/29412/LARGE/YvRyxN.jpeg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/image_up/29412/LARGE/YvRyxN.jpeg"
						}
					],
					"latlng": "35.6768865,139.7674333",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "82345",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/108656/108656.jpg"
						}
					],
					"latlng": "35.679752,139.7743006",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "14677",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "43016",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg",
							"thumbnailUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					],
					"latlng": "35.6768865,139.7739755",
					"lead": "per night per person",
					"point": "5673",
					"pointRatio": "10",
					"plans": [],
					"roomLeft": 4,
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				},
				{
					"id": "52456",
					"name": "Remm Akihabara",
					"rate": 4,
					"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
					"review": 3.92,
					"price": "3570",
					"currency": "JPY",
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/HOTEL/104626/104626.jpg"
						}
					],
					"latlng": "35.675219,139.763162",
					"plans": [],
					"provider": "38400000-8cf0-11bd-b23e-10b96e4ef00d"
				}
			],
			"filters": [
				{
					"id": "rate-5",
					"name": "5 Stars",
					"count": 0
				},
				{
					"id": "rate-4",
					"name": "4 Stars",
					"count": 0
				},
				{
					"id": "rate-3",
					"name": "3 Stars",
					"count": 0
				},
				{
					"id": "rate-2",
					"name": "2 Stars",
					"count": 0
				},
				{
					"id": "rate-1",
					"name": "1 Star",
					"count": 0
				},
				{
					"id": "hotel-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "hotel-creditcard",
					"name": "Credit cards accepted",
					"count": 68
				},
				{
					"id": "hotel-shuttle",
					"name": "Shuttle service available",
					"count": 54
				},
				{
					"id": "hotel-wheelchair",
					"name": "Wheelchair-accessible",
					"count": 0
				},
				{
					"id": "room-internet",
					"name": "Internet",
					"count": 0
				},
				{
					"id": "room-nonsmoking",
					"name": "Non-smoking",
					"count": 68
				},
				{
					"id": "room-smoking",
					"name": "Smoking",
					"count": 54
				},
				{
					"id": "room-washlet",
					"name": "Toilet with washlet",
					"count": 0
				},
				{
					"id": "meal-breakfast",
					"name": "Breakfast includes",
					"count": 54
				},
				{
					"id": "meal-dinner",
					"name": "Dinner includes",
					"count": 0
				}
			],
			"priceRange": {
				"min": 0,
				"max": 1000000
			}
		}
	},
	"*/v*/*/hotels/31571/rooms": {
		"GET": {
			"items": []
		}
	},
	"*/v*/*/hotels/19455/rooms?*price*": {
		"GET": {
			"items": [],
			"priceRange": {
				"min": "85.5",
				"max": "10000"
			}
		}
	},
	"*/v*/*/hotels/19455/rooms": {
		"GET": {
			"items": [
				{
					"name": "Main Tower Twins Room Lower Floor",
					"personLimit": "2",
					"smokingLead": "Smoking",
					"facilityLead": "With Bathroom and Toilet",
					"room": "11111",
					"plans": [
						{
							"id": "1234567",
							"name": "Room Only Plan",
							"price": "35.34",
							"currency": "US$",
							"priceLead": "per night per person",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19445/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19445/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
								}
							]
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19445/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19445/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/151118/origin/a7894a316be4934726a52984ecaca26510c4b213.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/043b90780fc26e6f550b74a3437168d0b0ab679e.47.1.26.2.jpg"
						},
						{
							"type": "image",
							"mediaUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg",
							"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/19455/origin/ec2f24850cf65765a43c26d487d28046458cbc32.47.1.26.2.jpg"
						}
					]
				},
				{
					"name": "Annex Tower Triple Room Higher Floor",
					"personLimit": "4",
					"smokingLead": "Smoking",
					"facilityLead": "With Bathroom and Toilet",
					"room": "22222",
					"plans": [
						{
							"id": "1234561",
							"name": "45Advanced Plated Breakfast",
							"price": "87040",
							"currency": "US$",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "12990",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"detail": "[ Features ]\n- Close to Shinbashi Station\n- Experience Japanese culture\n- Special price\n- Enjoy scenic views from your room\n\n[ Facilities ]\n- Complimentary access : premium television, Wifi, internet\n\n[ Activities ]\n- Experience Japanese culture : (visit shrines and temples, visit museums)\n- other : (sightseeing within the city )\n\n[ Reminder and Conditions ]\n*Recommended for guests who enjoy leisurely mornings.",
							"roomLeft": "2",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/IC9w6I.jpeg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/IC9w6I.jpeg"
								}
							]
						},
						{
							"id": "1234562",
							"name": "First-come-first-served! Early Booking Plan",
							"price": "3570",
							"currency": "JPY",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "332",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/gvjdmu.jpeg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/gvjdmu.jpeg"
								}
							]
						},
						{
							"id": "1234563",
							"name": "Highly Recommended! Multiple Night Stay Plan",
							"price": "43016",
							"currency": "JPY",
							"priceLead": "per night per person",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "5673",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1234564",
							"name": "Highly Recommended! Multiple Night Stay Plan",
							"price": "43016",
							"currency": "JPY",
							"priceLead": "per night per person",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "5673",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg"
								}
							]
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/image_up/72815/LARGE/cuNcOG.jpeg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/image_up/72815/LARGE/cuNcOG.jpeg"
						}
					]
				},
				{
					"name": "Annex Tower Triple Room Higher Floor",
					"personLimit": "4",
					"smokingLead": "Smoking",
					"facilityLead": "With Bathroom and Toilet",
					"room": "33333",
					"plans": [
						{
							"id": "1234571",
							"name": "45Advanced Plated Breakfast",
							"price": "87040",
							"currency": "US$",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "12990",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"detail": "[ Features ]\n- Close to Shinbashi Station\n- Experience Japanese culture\n- Special price\n- Enjoy scenic views from your room\n\n[ Facilities ]\n- Complimentary access : premium television, Wifi, internet\n\n[ Activities ]\n- Experience Japanese culture : (visit shrines and temples, visit museums)\n- other : (sightseeing within the city )\n\n[ Reminder and Conditions ]\n*Recommended for guests who enjoy leisurely mornings.",
							"roomLeft": "2",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/IC9w6I.jpeg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/IC9w6I.jpeg"
								}
							]
						},
						{
							"id": "1234572",
							"name": "First-come-first-served! Early Booking Plan",
							"price": "3570",
							"currency": "JPY",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "332",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/gvjdmu.jpeg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/11270/LARGE/gvjdmu.jpeg"
								}
							]
						},
						{
							"id": "1234573",
							"name": "Highly Recommended! Multiple Night Stay Plan",
							"price": "43016",
							"currency": "JPY",
							"priceLead": "per night per person",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "5673",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1234574",
							"name": "Highly Recommended! Multiple Night Stay Plan",
							"price": "43016",
							"currency": "JPY",
							"priceLead": "per night per person",
							"mealsLead": "Breakfast included",
							"paymentLead": "Pay at hotel or prepay with credit card",
							"point": "5673",
							"pointRatio": "10",
							"taxesAndFeedsLead": "Included: VAT 8%, service charge",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg",
									"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/38738/MIDDLE/41b291640d11a8ecfa6773f13ad56b08a68242e7.47.1.26.2.jpg"
								}
							]
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp//share/image_up/72815/LARGE/cuNcOG.jpeg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/image_up/72815/LARGE/cuNcOG.jpeg"
						}
					]
				}
			],
			"priceRange": {
				"min": "85.5",
				"max": "10000"
			}
		}
	},
	"*/v*/*/hotels/31571": {
		"GET": {
			"errors": [
				{
					"code": "",
					"message": "The page you are looking for could not be found"
				}
			]
		}
	},
	"*/v*/*/hotels/19455": {
		"GET": {
			"id": "19455",
			"name": "Shinagawa Prince Hotel",
			"rate": 4,
			"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
			"review": 3.92,
			"currency": "JPY",
			"latlng": "35.6768865,139.7674333",
			"priceLead": "per night per room",
			"address": "1-104-19 Totsuka-machi Shinjuku-ku Tokyo Tokyo-to",
			"description": "Mercure Hotel is located just nine minutes from the airport on the monorail one minute from Tsubogawa station. The first French-style hotel in Okinawa featuring French-style decor and dining. Features a banquet hall, meeting rooms and fax and copy services making it great for business and parties as well. Also located near the famous Kokusaidori shopping district and Shuri castle making it ideal for sightseeing. Boasts 260 modern and stylish rooms with all the amenities you need. WiFi internet access available in all rooms. In 1999, 148 hotels were integrated into the network, including 42 Libertel hotels, 27 hotels in Germany and 27 in Australia. New hotels were opened in Algeria, Morocco, Mauritania, Jordan, Lebanon, Saudi Arabia, and Yemen. In 2014, Mercure hotel was opened in Latvia. On February 19, 2015 The Grand Hotel, Mercure Leicester, held an official re-opening ceremony after the completion of an extensive renovation. The Mercure Abu Dhabi Center Hotel recycles 30 percent of its approximately 1.9 tonnes of waste each month. Built in 1979 and renovated in 1997 the Mercure Abu Dhabi is one of the country’s oldest hotels. Since implementation of their recycling program the hotel’s water bills have plummeted by 25 percent and their electric bills are down by 10 percent. Mercure announced the addition of three hotels to their brand in Recife, Brazil in February, 2015. With the expectation of opening by May 2015, the hotels will replace three from the Pontes Hotels &amp; Resorts network. The new hotels will be the Mercure Recife Mar Hotels Conventions, the Grand Mercure Recife Atlante Plaza, and the Grand Mercure Summerville Resort.",
			"media": [
				{
					"type": "image",
					"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/origin/355cd97014a4da77a78ac2fe2a2e45f4d115bad8.47.1.26.2.jpg",
					"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/origin/355cd97014a4da77a78ac2fe2a2e45f4d115bad8.47.1.26.2.jpg"
				},
				{
					"type": "image",
					"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/GmUFsE.jpeg",
					"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/GmUFsE.jpeg"
				},
				{
					"type": "image",
					"mediaUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/dlG4kI.jpeg",
					"thumbnailUrl": "http://trvimg.r10s.jp/share/image_up/9290/LARGE/dlG4kI.jpeg"
				},
				{
					"type": "image",
					"mediaUrl": "http://img.travel.rakuten.co.jp//share/image_up/29412/LARGE/YvRyxN.jpeg",
					"thumbnailUrl": "http://img.travel.rakuten.co.jp//share/image_up/29412/LARGE/YvRyxN.jpeg"
				}
			],
			"facilities": [
				{
					"type": "hotel",
					"name": "restaurant"
				},
				{
					"type": "hotel",
					"name": "cafe"
				},
				{
					"type": "hotel",
					"name": "lounge"
				},
				{
					"type": "hotel",
					"name": "non-smoking rooms"
				},
				{
					"type": "hotel",
					"name": "shop"
				},
				{
					"type": "hotel",
					"name": "vending machine"
				},
				{
					"type": "hotel",
					"name": "coin laundry(pay to use)"
				},
				{
					"type": "hotel",
					"name": "spa"
				},
				{
					"type": "hotel",
					"name": "connecting room"
				},
				{
					"type": "room",
					"name": "TV"
				},
				{
					"type": "room",
					"name": "satellite TV"
				},
				{
					"type": "room",
					"name": "video on demand"
				},
				{
					"type": "room",
					"name": "satellite TV(additional charge)"
				},
				{
					"type": "room",
					"name": "telephone"
				},
				{
					"type": "room",
					"name": "internet(LAN)"
				},
				{
					"type": "room",
					"name": "internet(WiFi)"
				},
				{
					"type": "room",
					"name": "electric kettle tea set"
				},
				{
					"type": "room",
					"name": "refrigirator"
				},
				{
					"type": "room",
					"name": "hair dryer"
				},
				{
					"type": "room",
					"name": "trouser press"
				},
				{
					"type": "room",
					"name": "trouser press(available to borrow)"
				},
				{
					"type": "room",
					"name": "desk lamp(available to borrow)"
				},
				{
					"type": "room",
					"name": "iron(available to borrow)"
				},
				{
					"type": "room",
					"name": "humidifier"
				},
				{
					"type": "service",
					"name": "laundry service"
				},
				{
					"type": "service",
					"name": "satellite TV"
				},
				{
					"type": "service",
					"name": "video on demand"
				},
				{
					"type": "service",
					"name": "satellite TV(additional charge)"
				},
				{
					"type": "service",
					"name": "telephone"
				},
				{
					"type": "service",
					"name": "internet(LAN)"
				},
				{
					"type": "service",
					"name": "internet(WiFi)"
				},
				{
					"type": "service",
					"name": "electric kettle tea set"
				},
				{
					"type": "service",
					"name": "refrigirator"
				},
				{
					"type": "service",
					"name": "hair dryer"
				},
				{
					"type": "service",
					"name": "trouser press"
				},
				{
					"type": "service",
					"name": "trouser press(available to borrow)"
				},
				{
					"type": "service",
					"name": "desk lamp(available to borrow)"
				},
				{
					"type": "service",
					"name": "iron(available to borrow)"
				},
				{
					"type": "service",
					"name": "humidifier"
				}
			],
			"about": [
				{
					"label": "Check-in",
					"text": "14:00 ~ 24:00"
				},
				{
					"label": "Check-out",
					"text": "11:00"
				},
				{
					"label": "Contact information",
					"list": [
						{
							"title": "Phone number :",
							"detail": "03-5803-2155"
						},
						{
							"title": "Fax number :",
							"detail": "03-5123-2145"
						}
					]
				},
				{
					"label": "Closest station",
					"text": "5 minutes on foot from Suidobashi station"
				},
				{
					"label": "Parking",
					"text": "100 cars. you have to contact."
				}
			],
			"cards": [
				{
					"id": "visa",
					"name": "VISA"
				},
				{
					"id": "mastercard",
					"name": "Mastercard"
				},
				{
					"id": "amex",
					"name": "Amex"
				},
				{
					"id": "diners",
					"name": "Diners"
				}
			],
			"others": {
				"breakfast": "restaurant(buffet)",
				"dinner": "room, restaurant(buffet)",
				"bathroom": [
					"hot springs",
					"large communal bath",
					"open-air bath",
					"sauna",
					"family bath",
					"artificial hot spring",
					"cold bath",
					"natural hot spring"
				],
				"accessibility": [
					"wheelchair-accessible",
					"wheelchair rental available",
					"barrier-free room",
					"wheelchair-accessible guest rooms available"
				],
				"nearby": [
					"golf",
					"hiking",
					"skiing",
					"sauna",
					"horse-riding",
					"aquarium",
					"theme park"
				]
			},
			"notes": [
				{
					"note": "If you are late for check-in time, please call the hotel directly. There is no closing time. Extra bed is not available."
				},
				{
					"note": "2nd Note"
				}
			],
			"cancelpolicies": {
				"description": "Should you cancel your booking, a cancellation fee will be charged to you according to the date (Japan Standard Time) the booking changes and cancellation request are accepted.",
				"policies": [
					{
						"lead": "No-show",
						"cancellation": "100%"
					},
					{
						"lead": "On the date of arrival",
						"cancellation": "80%"
					},
					{
						"lead": "One day prior to arrival",
						"cancellation": "0%"
					}
				]
			},
			"status": "OPEN"
		}
	},
	"*/v*/*/hotels/93421": {
		"GET": {
			"items": [
				{
					"name": "別墅豪華海景DELUXESUITE",
					"personLimit": "5",
					"smokingLead": "禁煙",
					"facilityLead": "帶露天溫泉/*3個人一起用時，我們準備臨時床。",
					"room": "test050702",
					"plans": [
						{
							"id": "1570669",
							"name": "無限使用網絡！BBB",
							"price": "42.12",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "288",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 可以看煙火<br/>- 指定無障礙客房<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1286062",
							"name": "享受溫泉！生日住宿套餐",
							"price": "46.8",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:已包含",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "320",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 贈送驚喜禮物<br/>- 優惠的價格<br/>- 可以一人入住<br/>- 讓人放心的接送服務<br/><br/>[ 免費升級 ]<br/>-  : 升級到套房<br/><br/>[ 館內設施利用 ]<br/>- 免費使用 : 網絡, 英文報紙<br/>- 禮物 : 迎賓飲料, 日本特產<br/>",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1570667",
							"name": "住宿套餐",
							"price": "84.23",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "576",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "住宿套餐",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1286063",
							"name": "帶早餐、晚餐PLAN",
							"price": "280.8",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "信用卡線上預付",
							"point": "1920",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天",
							"roomLeft": "",
							"media": []
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg"
						}
					]
				},
				{
					"name": "標準 雙床間",
					"personLimit": "5",
					"smokingLead": "禁煙",
					"facilityLead": "帶淋浴和衛生間",
					"room": "test050706",
					"plans": [
						{
							"id": "1570668",
							"name": "Rakuten Travel獨家特惠！AAAA",
							"price": "374.4",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "2560",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 設有貸切風呂<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "主樓標準花園景單人間",
					"personLimit": "5",
					"smokingLead": "吸煙",
					"facilityLead": "帶洗澡間和衛生間/3人入住時提供加床。",
					"room": "test050701",
					"plans": [
						{
							"id": "1286062",
							"name": "享受溫泉！生日住宿套餐",
							"price": "37.07",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "252",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 贈送驚喜禮物<br/>- 優惠的價格<br/>- 可以一人入住<br/>- 讓人放心的接送服務<br/><br/>[ 免費升級 ]<br/>-  : 升級到套房<br/><br/>[ 館內設施利用 ]<br/>- 免費使用 : 網絡, 英文報紙<br/>- 禮物 : 迎賓飲料, 日本特產<br/>",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1570673",
							"name": "TestPlan08",
							"price": "42.12",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "288",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570667",
							"name": "住宿套餐",
							"price": "46.8",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "320",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "住宿套餐",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1570675",
							"name": "TestPlan10",
							"price": "74.87",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "512",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 住宿折扣優惠 ]<br/>- 連住折扣優惠 : 連住5晚享受10%優惠<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570669",
							"name": "無限使用網絡！BBB",
							"price": "103.99",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "710",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 可以看煙火<br/>- 指定無障礙客房<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570671",
							"name": "TestPlan06",
							"price": "307.48",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "2102",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570676",
							"name": "TestPlan11",
							"price": "374.4",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "2560",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570672",
							"name": "TestPlan07TestPlan07TestPlan07TestPlan07TestPlan07",
							"price": "561.54",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:已包含",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "3842",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內5次(日式料理, 美式早餐, 可以換成午餐, 歐式早餐, 自助餐)<br/>- 晚餐 : 入住期間內5次(日式料理（沒有指定）, 日式料理（刺身/海鮮）, 日式料理（全蟹宴）, 日式料理（全蝦宴）, 日式料理（肉料理）)<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/32ce01e21b9bd8ebcd416e679a7dc20a38bbf8e4.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/32ce01e21b9bd8ebcd416e679a7dc20a38bbf8e4.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg"
						}
					]
				},
				{
					"name": "4 BED ROOM",
					"personLimit": "10",
					"smokingLead": "",
					"facilityLead": "帶淋浴·衛生間　",
					"room": "test050703",
					"plans": [
						{
							"id": "1570669",
							"name": "無限使用網絡！BBB",
							"price": "28.08",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "192",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 可以看煙火<br/>- 指定無障礙客房<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570671",
							"name": "TestPlan06",
							"price": "45.94",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "314",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1286062",
							"name": "享受溫泉！生日住宿套餐",
							"price": "46.8",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "320",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 贈送驚喜禮物<br/>- 優惠的價格<br/>- 可以一人入住<br/>- 讓人放心的接送服務<br/><br/>[ 免費升級 ]<br/>-  : 升級到套房<br/><br/>[ 館內設施利用 ]<br/>- 免費使用 : 網絡, 英文報紙<br/>- 禮物 : 迎賓飲料, 日本特產<br/>",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1570668",
							"name": "Rakuten Travel獨家特惠！AAAA",
							"price": "74.87",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "512",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 設有貸切風呂<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1286063",
							"name": "帶早餐、晚餐PLAN",
							"price": "468",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "信用卡線上預付",
							"point": "3202",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天",
							"roomLeft": "",
							"media": []
						}
					],
					"media": [
						{
							"type": "image",
							"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/bf235aaf6ed3af5a5045ecdb9c523b9fa1a06a38.82.1.26.2.jpg",
							"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/bf235aaf6ed3af5a5045ecdb9c523b9fa1a06a38.82.1.26.2.jpg"
						}
					]
				},
				{
					"name": "準西洋式間",
					"personLimit": "10",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050704",
					"plans": [
						{
							"id": "1570668",
							"name": "Rakuten Travel獨家特惠！AAAA",
							"price": "664.65",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:已包含",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "4546",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 設有貸切風呂<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/1ffd92e6f6fe6609e1f11eae87495d02d866b52c.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570669",
							"name": "無限使用網絡！BBB",
							"price": "936",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "6404",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 可以看煙火<br/>- 指定無障礙客房<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "日式間",
					"personLimit": "50",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050713",
					"plans": [
						{
							"id": "1667323",
							"name": "Plan13",
							"price": "42.12",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:已包含 / 晚餐:已包含",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "288",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- Rakuten Travel Only<br/><br/>[ 關于住宿PLAN的條件以及注意事項 ]<br/>※請注意！如果不符合標註條件，住宿套餐特惠將會無效。（例如：學生必看！經濟型PLAN → 需要出示學生證）<br/>※學生需要攜帶學生證。并請在入住check in時出示。<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2fd59c180bf580591f832b4800ff6bacd0c19e53.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2fd59c180bf580591f832b4800ff6bacd0c19e53.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "標準 雙床間",
					"personLimit": "5",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050705",
					"plans": [
						{
							"id": "1286062",
							"name": "享受溫泉！生日住宿套餐",
							"price": "46.8",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "320",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 贈送驚喜禮物<br/>- 優惠的價格<br/>- 可以一人入住<br/>- 讓人放心的接送服務<br/><br/>[ 免費升級 ]<br/>-  : 升級到套房<br/><br/>[ 館內設施利用 ]<br/>- 免費使用 : 網絡, 英文報紙<br/>- 禮物 : 迎賓飲料, 日本特產<br/>",
							"roomLeft": "",
							"media": []
						},
						{
							"id": "1570669",
							"name": "無限使用網絡！BBB",
							"price": "468",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "3202",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 可以看煙火<br/>- 指定無障礙客房<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "標準 間",
					"personLimit": "10",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050711",
					"plans": [
						{
							"id": "1570676",
							"name": "TestPlan11",
							"price": "46.8",
							"currency": "USD",
							"priceLead": "每人每晚",
							"mealsLead": "早餐:無 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "320",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "私家泳池別墅總統半海景套間行政層",
					"personLimit": "10",
					"smokingLead": "禁煙",
					"facilityLead": "帶洗澡間和衛生間/4人入住時提供加床。",
					"room": "test050712",
					"plans": [
						{
							"id": "1598451",
							"name": "TestPlan12",
							"price": "63.18",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "432",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 這個PLAN的賣點 ]<br/>- 享受美食<br/>- 享受溫泉<br/>- 可以體驗日本文化<br/>- 可以感受自然<br/>- 從客房能欣賞到美麗景色<br/><br/>[ 住宿折扣優惠 ]<br/>- 連住折扣優惠 : 連住35晚享受1%優惠<br/><br/>[ 用餐 ]<br/>- 早餐 : 入住期間內每天(自助餐)<br/>- 晚餐 : 入住期間內1次(中華料理)<br/>- 晚餐期间有助兴表演 : 入住期間內1次(BBQ)<br/><br/>[ SPA・按摩 ]<br/>- SPA : 基本療程5分鐘免費<br/><br/>[ 其他的服務 ]<br/>- 機場接送 : 單程（從Haneda機場到酒店）使用私家豪華轎車(收費（住宿套餐以外的額外費用）)<br/>- 提早入住 : 從12:00開始<br/>- 延遲入住 : 從15:00開始<br/>- 延遲退房 : 截止到10:00<br/>- 可在客房Check in<br/><br/>[ 關于住宿PLAN的條件以及注意事項 ]<br/>※如果需要接送服務，請提前4天直接告知酒店。(電子郵件, 電話)<br/>※料理的內容可能會根據季節做出適當變更。<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/c540d0054545753866188c3959511977978682f5.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/c540d0054545753866188c3959511977978682f5.82.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/901294b627d0f5f1fff3dd0334813b70a7803eed.82.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/32ce01e21b9bd8ebcd416e679a7dc20a38bbf8e4.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/32ce01e21b9bd8ebcd416e679a7dc20a38bbf8e4.82.1.26.2.jpg"
								},
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/2ed274052b272470a0599acc88522380d8a26cbe.82.1.26.2.jpg"
								}
							]
						},
						{
							"id": "1570676",
							"name": "TestPlan11",
							"price": "131.41",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "898",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>- 晚餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/8660a2c3989a7c8f178a552ce0a7218144e859ef.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "間",
					"personLimit": "7",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050710",
					"plans": [
						{
							"id": "1570675",
							"name": "TestPlan10",
							"price": "467.53",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:已包含",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "3198",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 住宿折扣優惠 ]<br/>- 連住折扣優惠 : 連住5晚享受10%優惠<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				},
				{
					"name": "套房 四人間",
					"personLimit": "5",
					"smokingLead": "",
					"facilityLead": "帶洗澡間和衛生間",
					"room": "test050708",
					"plans": [
						{
							"id": "1570673",
							"name": "TestPlan08",
							"price": "850.66",
							"currency": "USD",
							"priceLead": "每房每晚",
							"mealsLead": "早餐:已包含 / 晚餐:無",
							"paymentLead": "在飯店付款/信用卡線上預付",
							"point": "5820",
							"pointRatio": "20",
							"taxesAndFeedsLead": "已包括增值稅 (8%) 及服務費",
							"detail": "[ 用餐 ]<br/>- 早餐 : 入住期間內每天<br/>",
							"roomLeft": "",
							"media": [
								{
									"type": "image",
									"mediaUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg",
									"thumbnailUrl": "http://img.travel.rakuten.co.jp/share/image_up/93421/LARGE/ef12b9a607a9fd9c89085e2ada306b955a034627.82.1.26.2.jpg"
								}
							]
						}
					],
					"media": []
				}
			],
			"priceRange": {
				"min": "10",
				"max": "1000"
			}
		}
	},
	"*/v*/*/navigations": {
		"GET": {
			"subdivisions": [
				{
					"id": "Aichi",
					"name": "Aichi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Akita",
					"name": "Akita",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Aomori",
					"name": "Aomori",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Chiba",
					"name": "Chiba",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Ehime",
					"name": "Ehime",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Fukui",
					"name": "Fukui",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Fukuoka",
					"name": "Fukuoka",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Fukushima",
					"name": "Fukushima",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Gifu",
					"name": "Gifu",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Gunma",
					"name": "Gunma",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Hiroshima",
					"name": "Hiroshima",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Hokkaido",
					"name": "Hokkaido",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Hyogo",
					"name": "Hyogo",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Ibaraki",
					"name": "Ibaraki",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Ishikawa",
					"name": "Ishikawa",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Iwate",
					"name": "Iwate",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kagawa",
					"name": "Kagawa",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kagoshima",
					"name": "Kagoshima",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kanagawa",
					"name": "Kanagawa",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kochi",
					"name": "Kochi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kumamoto",
					"name": "Kumamoto",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Kyoto",
					"name": "Kyoto",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Mie",
					"name": "Mie",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Miyagi",
					"name": "Miyagi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Miyazaki",
					"name": "Miyazaki",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Nagano",
					"name": "Nagano",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Nagasaki",
					"name": "Nagasaki",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Nara",
					"name": "Nara",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Niigata",
					"name": "Niigata",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Oita",
					"name": "Oita",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Okayama",
					"name": "Okayama",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Okinawa",
					"name": "Okinawa",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Osaka",
					"name": "Osaka",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Saga",
					"name": "Saga",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Saitama",
					"name": "Saitama",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Shiga",
					"name": "Shiga",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Shimane",
					"name": "Shimane",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Shizuoka",
					"name": "Shizuoka",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Tochigi",
					"name": "Tochigi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Tokushima",
					"name": "Tokushima",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Tokyo",
					"name": "Tokyo",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Tottori",
					"name": "Tottori",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Toyama",
					"name": "Toyama",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Wakayama",
					"name": "Wakayama",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Yamagata",
					"name": "Yamagata",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Yamaguchi",
					"name": "Yamaguchi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Yamanashi",
					"name": "Yamanashi",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				},
				{
					"id": "Lorem ipsum dolor sit amet, consectetuer adipisc50",
					"name": "Lorem ipsum dolor sit amet, consectetuer adipisc50",
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture"
				}
			],
			"cities": [
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
					"id": "Akasaka Sacas",
					"name": "Akasaka Sacas"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
					"id": "Ameyoko",
					"name": "Ameyoko"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
					"id": "Edo Tokyo Museum",
					"name": "Edo Tokyo Museum"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
					"id": "Hama Rikyu",
					"name": "Hama Rikyu"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
					"id": "Harajuku",
					"name": "Harajuku"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
					"id": "Imperial Palace East Gardens",
					"name": "Imperial Palace East Gardens"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
					"id": "Institute for Nature Study",
					"name": "Institute for Nature Study"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
					"id": "Kagurazaka",
					"name": "Kagurazaka"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
					"id": "Kappabashi Street",
					"name": "Kappabashi Street"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
					"id": "Dummy start",
					"name": "Dummy start"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hiroshima_Prefecture",
					"id": "Hiroshima Prefecture",
					"name": "Hiroshima Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hokkaido",
					"id": "Hokkaido",
					"name": "Hokkaido"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hyogo_Prefecture",
					"id": "Hyogo Prefecture",
					"name": "Hyogo Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ibaraki_Prefecture",
					"id": "Ibaraki Prefecture",
					"name": "Ibaraki Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ishikawa_Prefecture",
					"id": "Ishikawa Prefecture",
					"name": "Ishikawa Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Iwate_Prefecture",
					"id": "Iwate Prefecture",
					"name": "Iwate Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagawa_Prefecture",
					"id": "Kagawa Prefecture",
					"name": "Kagawa Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagoshima_Prefecture",
					"id": "Kagoshima Prefecture",
					"name": "Kagoshima Prefecture"
				},
				{
					"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kanagawa_Prefecture",
					"id": "Kanagawa Prefecture",
					"name": "Kanagawa Prefecture"
				}
			],
			"spotTypes": [
				{
					"id": "Landmarks",
					"name": "Landmarks",
					"spots": [
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
							"id": "Akasaka Sacas",
							"name": "Akasaka Sacas"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
							"id": "Ameyoko",
							"name": "Ameyoko"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
							"id": "Edo Tokyo Museum",
							"name": "Edo Tokyo Museum"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
							"id": "Hama Rikyu",
							"name": "Hama Rikyu"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
							"id": "Harajuku",
							"name": "Harajuku"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
							"id": "Imperial Palace East Gardens",
							"name": "Imperial Palace East Gardens"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
							"id": "Institute for Nature Study",
							"name": "Institute for Nature Study"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
							"id": "Kagurazaka",
							"name": "Kagurazaka"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
							"id": "Kappabashi Street",
							"name": "Kappabashi Street"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
							"id": "Dummy start",
							"name": "Dummy start"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hiroshima_Prefecture",
							"id": "Hiroshima Prefecture",
							"name": "Hiroshima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hokkaido",
							"id": "Hokkaido",
							"name": "Hokkaido"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hyogo_Prefecture",
							"id": "Hyogo Prefecture",
							"name": "Hyogo Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ibaraki_Prefecture",
							"id": "Ibaraki Prefecture",
							"name": "Ibaraki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ishikawa_Prefecture",
							"id": "Ishikawa Prefecture",
							"name": "Ishikawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Iwate_Prefecture",
							"id": "Iwate Prefecture",
							"name": "Iwate Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagawa_Prefecture",
							"id": "Kagawa Prefecture",
							"name": "Kagawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagoshima_Prefecture",
							"id": "Kagoshima Prefecture",
							"name": "Kagoshima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kanagawa_Prefecture",
							"id": "Kanagawa Prefecture",
							"name": "Kanagawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kochi_Prefecture",
							"id": "Kochi Prefecture",
							"name": "Kochi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kumamoto_Prefecture",
							"id": "Kumamoto Prefecture",
							"name": "Kumamoto Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kyoto_Prefecture",
							"id": "Kyoto Prefecture",
							"name": "Kyoto Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Mie_Prefecture",
							"id": "Mie Prefecture",
							"name": "Mie Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Miyagi_Prefecture",
							"id": "Miyagi Prefecture",
							"name": "Miyagi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Miyazaki_Prefecture",
							"id": "Miyazaki Prefecture",
							"name": "Miyazaki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nagano_Prefecture",
							"id": "Nagano Prefecture",
							"name": "Nagano Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nagasaki_Prefecture",
							"id": "Nagasaki Prefecture",
							"name": "Nagasaki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nara_Prefecture",
							"id": "Nara Prefecture",
							"name": "Nara Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Niigata_Prefecture",
							"id": "Niigata Prefecture",
							"name": "Niigata Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Oita_Prefecture",
							"id": "Oita Prefecture",
							"name": "Oita Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Okayama_Prefecture",
							"id": "Okayama Prefecture",
							"name": "Okayama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Okinawa_Prefecture",
							"id": "Okinawa Prefecture",
							"name": "Okinawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Osaka_Prefecture",
							"id": "Osaka Prefecture",
							"name": "Osaka Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Saga_Prefecture",
							"id": "Saga Prefecture",
							"name": "Saga Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Saitama_Prefecture",
							"id": "Saitama Prefecture",
							"name": "Saitama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shiga_Prefecture",
							"id": "Shiga Prefecture",
							"name": "Shiga Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shimane_Prefecture",
							"id": "Shimane Prefecture",
							"name": "Shimane Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shizuoka_Prefecture",
							"id": "Shizuoka Prefecture",
							"name": "Shizuoka Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tochigi_Prefecture",
							"id": "Tochigi Prefecture",
							"name": "Tochigi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokushima_Prefecture",
							"id": "Tokushima Prefecture",
							"name": "Tokushima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
							"id": "Tokyo Prefecture",
							"name": "Tokyo Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tottori_Prefecture",
							"id": "Tottori Prefecture",
							"name": "Tottori Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Toyama_Prefecture",
							"id": "Toyama Prefecture",
							"name": "Toyama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Wakayama_Prefecture",
							"id": "Wakayama Prefecture",
							"name": "Wakayama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamagata_Prefecture",
							"id": "Yamagata Prefecture",
							"name": "Yamagata Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamaguchi_Prefecture",
							"id": "Yamaguchi Prefecture",
							"name": "Yamaguchi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamanashi_Prefecture",
							"id": "Yamanashi Prefecture",
							"name": "Yamanashi Prefecture"
						}
					]
				},
				{
					"id": "Onsen",
					"name": "Onsen",
					"spots": [
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
							"id": "Akasaka Sacas",
							"name": "Akasaka Sacas"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
							"id": "Ameyoko",
							"name": "Ameyoko"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
							"id": "Edo Tokyo Museum",
							"name": "Edo Tokyo Museum"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
							"id": "Hama Rikyu",
							"name": "Hama Rikyu"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
							"id": "Harajuku",
							"name": "Harajuku"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
							"id": "Imperial Palace East Gardens",
							"name": "Imperial Palace East Gardens"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
							"id": "Institute for Nature Study",
							"name": "Institute for Nature Study"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
							"id": "Kagurazaka",
							"name": "Kagurazaka"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
							"id": "Kappabashi Street",
							"name": "Kappabashi Street"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
							"id": "Dummy start",
							"name": "Dummy start"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hiroshima_Prefecture",
							"id": "Hiroshima Prefecture",
							"name": "Hiroshima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hokkaido",
							"id": "Hokkaido",
							"name": "Hokkaido"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Hyogo_Prefecture",
							"id": "Hyogo Prefecture",
							"name": "Hyogo Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ibaraki_Prefecture",
							"id": "Ibaraki Prefecture",
							"name": "Ibaraki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ishikawa_Prefecture",
							"id": "Ishikawa Prefecture",
							"name": "Ishikawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Iwate_Prefecture",
							"id": "Iwate Prefecture",
							"name": "Iwate Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagawa_Prefecture",
							"id": "Kagawa Prefecture",
							"name": "Kagawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kagoshima_Prefecture",
							"id": "Kagoshima Prefecture",
							"name": "Kagoshima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kanagawa_Prefecture",
							"id": "Kanagawa Prefecture",
							"name": "Kanagawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kochi_Prefecture",
							"id": "Kochi Prefecture",
							"name": "Kochi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kumamoto_Prefecture",
							"id": "Kumamoto Prefecture",
							"name": "Kumamoto Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Kyoto_Prefecture",
							"id": "Kyoto Prefecture",
							"name": "Kyoto Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Mie_Prefecture",
							"id": "Mie Prefecture",
							"name": "Mie Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Miyagi_Prefecture",
							"id": "Miyagi Prefecture",
							"name": "Miyagi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Miyazaki_Prefecture",
							"id": "Miyazaki Prefecture",
							"name": "Miyazaki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nagano_Prefecture",
							"id": "Nagano Prefecture",
							"name": "Nagano Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nagasaki_Prefecture",
							"id": "Nagasaki Prefecture",
							"name": "Nagasaki Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Nara_Prefecture",
							"id": "Nara Prefecture",
							"name": "Nara Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Niigata_Prefecture",
							"id": "Niigata Prefecture",
							"name": "Niigata Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Oita_Prefecture",
							"id": "Oita Prefecture",
							"name": "Oita Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Okayama_Prefecture",
							"id": "Okayama Prefecture",
							"name": "Okayama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Okinawa_Prefecture",
							"id": "Okinawa Prefecture",
							"name": "Okinawa Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Osaka_Prefecture",
							"id": "Osaka Prefecture",
							"name": "Osaka Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Saga_Prefecture",
							"id": "Saga Prefecture",
							"name": "Saga Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Saitama_Prefecture",
							"id": "Saitama Prefecture",
							"name": "Saitama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shiga_Prefecture",
							"id": "Shiga Prefecture",
							"name": "Shiga Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shimane_Prefecture",
							"id": "Shimane Prefecture",
							"name": "Shimane Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Shizuoka_Prefecture",
							"id": "Shizuoka Prefecture",
							"name": "Shizuoka Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tochigi_Prefecture",
							"id": "Tochigi Prefecture",
							"name": "Tochigi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokushima_Prefecture",
							"id": "Tokushima Prefecture",
							"name": "Tokushima Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tokyo_Prefecture",
							"id": "Tokyo Prefecture",
							"name": "Tokyo Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Tottori_Prefecture",
							"id": "Tottori Prefecture",
							"name": "Tottori Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Toyama_Prefecture",
							"id": "Toyama Prefecture",
							"name": "Toyama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Wakayama_Prefecture",
							"id": "Wakayama Prefecture",
							"name": "Wakayama Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamagata_Prefecture",
							"id": "Yamagata Prefecture",
							"name": "Yamagata Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamaguchi_Prefecture",
							"id": "Yamaguchi Prefecture",
							"name": "Yamaguchi Prefecture"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Yamanashi_Prefecture",
							"id": "Yamanashi Prefecture",
							"name": "Yamanashi Prefecture"
						}
					]
				},
				{
					"id": "Airports",
					"name": "Airports",
					"spots": [
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
							"id": "Akasaka Sacas",
							"name": "Akasaka Sacas"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
							"id": "Ameyoko",
							"name": "Ameyoko"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
							"id": "Edo Tokyo Museum",
							"name": "Edo Tokyo Museum"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
							"id": "Hama Rikyu",
							"name": "Hama Rikyu"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
							"id": "Harajuku",
							"name": "Harajuku"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
							"id": "Imperial Palace East Gardens",
							"name": "Imperial Palace East Gardens"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
							"id": "Institute for Nature Study",
							"name": "Institute for Nature Study"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
							"id": "Kagurazaka",
							"name": "Kagurazaka"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
							"id": "Kappabashi Street",
							"name": "Kappabashi Street"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
							"id": "Dummy start",
							"name": "Dummy start"
						}
					]
				},
				{
					"id": "Stations",
					"name": "Train/Metro Stations",
					"spots": [
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
							"id": "Akasaka Sacas",
							"name": "Akasaka Sacas"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
							"id": "Ameyoko",
							"name": "Ameyoko"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
							"id": "Edo Tokyo Museum",
							"name": "Edo Tokyo Museum"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
							"id": "Hama Rikyu",
							"name": "Hama Rikyu"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
							"id": "Harajuku",
							"name": "Harajuku"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
							"id": "Imperial Palace East Gardens",
							"name": "Imperial Palace East Gardens"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
							"id": "Institute for Nature Study",
							"name": "Institute for Nature Study"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
							"id": "Kagurazaka",
							"name": "Kagurazaka"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
							"id": "Kappabashi Street",
							"name": "Kappabashi Street"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
							"id": "Dummy start",
							"name": "Dummy start"
						}
					]
				},
				{
					"id": "Districts",
					"name": "Districts",
					"iconUrl": "http://img.travel.rakuten.co.jp/.......png",
					"spots": [
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aichi_Prefecture",
							"id": "Akasaka Sacas",
							"name": "Akasaka Sacas"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Akita_Prefecture",
							"id": "Ameyoko",
							"name": "Ameyoko"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Aomori_Prefecture",
							"id": "Edo Tokyo Museum",
							"name": "Edo Tokyo Museum"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Chiba_Prefecture",
							"id": "Hama Rikyu",
							"name": "Hama Rikyu"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Ehime_Prefecture",
							"id": "Harajuku",
							"name": "Harajuku"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukui_Prefecture",
							"id": "Imperial Palace East Gardens",
							"name": "Imperial Palace East Gardens"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukuoka_Prefecture",
							"id": "Institute for Nature Study",
							"name": "Institute for Nature Study"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Fukushima_Prefecture",
							"id": "Kagurazaka",
							"name": "Kagurazaka"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gifu_Prefecture",
							"id": "Kappabashi Street",
							"name": "Kappabashi Street"
						},
						{
							"pageUrl": "http://travel.rakuten.com/hotellist/Japan-Gunma_Prefecture",
							"id": "Dummy start",
							"name": "Dummy start"
						}
					]
				}
			]
		}
	},
	"*/v*/*/notifications": {
		"GET": {
			"items": [
				{
					"pageUrl": "http://rakuten-travel-en.custhelp.com/",
					"text": "Server Maintenance Notification – Saturday (November 24th 2016)"
				},
				{
					"pageUrl": "http://rakuten-travel-en.custhelp.com/",
					"text": "The Earthquake Early Warning (EEW) is a warning issued."
				}
			]
		}
	},
	"*/v*/*/recommendations": {
		"GET": {
			"items": [
				{
					"name": "Tokyo",
					"pageUrl": "/hotellist/Japan-Tokyo_Prefecture",
					"imageUrl": "http://40.media.tumblr.com/tumblr_l9dbx4G0Qs1qbm1xco1_1280.jpg",
					"places": [
						{
							"name": "Remm Akihabara",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "http://img.travel.rakuten.co.jp/share/HOTEL/107870/107870.jpg"
						},
						{
							"name": "Shinagawa Prince Hotel",
							"review": 4.43,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Mitsui Garden Ginza",
							"logoAlt": "voyagin",
							"logoUrl": "https://voyagin.sslcs.cdngc.net/assets/common/logo-d9606888c6b8795a7f970887ec8675ca.svg",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://res.cloudinary.com/hstcxjula/image/upload/b_black,c_fill,f_auto,fl_keep_iptc,h_425,w_528/v1426069132/wd8tf3ig680kfqfmmkpq.jpg"
						},
						{
							"name": "Mets inn",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Asakusa View Hotel",
							"logoUrl": "http://gora.golf.rakuten.co.jp/img/rc-h-logo.gif",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Hilton Hotel Kyobashi",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					]
				},
				{
					"name": "Osaka",
					"pageUrl": "/hotellist/Japan-Tokyo_Prefecture",
					"imageUrl": "http://40.media.tumblr.com/tumblr_l9dbx4G0Qs1qbm1xco1_1280.jpg",
					"places": [
						{
							"name": "Remm Akihabara",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "http://img.travel.rakuten.co.jp/share/HOTEL/107870/107870.jpg"
						},
						{
							"name": "Shinagawa Prince Hotel",
							"review": 4.43,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Mitsui Garden Ginza",
							"logoAlt": "voyagin",
							"logoUrl": "https://voyagin.sslcs.cdngc.net/assets/common/logo-d9606888c6b8795a7f970887ec8675ca.svg",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://res.cloudinary.com/hstcxjula/image/upload/b_black,c_fill,f_auto,fl_keep_iptc,h_425,w_528/v1426069132/wd8tf3ig680kfqfmmkpq.jpg"
						},
						{
							"name": "Mets inn",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Asakusa View Hotel",
							"logoUrl": "http://gora.golf.rakuten.co.jp/img/rc-h-logo.gif",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Hilton Hotel Kyobashi",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					]
				},
				{
					"name": "Kyoto",
					"pageUrl": "/hotellist/Japan-Tokyo_Prefecture",
					"imageUrl": "http://40.media.tumblr.com/tumblr_l9dbx4G0Qs1qbm1xco1_1280.jpg",
					"places": [
						{
							"name": "Remm Akihabara",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "http://img.travel.rakuten.co.jp/share/HOTEL/107870/107870.jpg"
						},
						{
							"name": "Shinagawa Prince Hotel",
							"review": 4.43,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Mitsui Garden Ginza",
							"logoAlt": "voyagin",
							"logoUrl": "https://voyagin.sslcs.cdngc.net/assets/common/logo-d9606888c6b8795a7f970887ec8675ca.svg",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://res.cloudinary.com/hstcxjula/image/upload/b_black,c_fill,f_auto,fl_keep_iptc,h_425,w_528/v1426069132/wd8tf3ig680kfqfmmkpq.jpg"
						},
						{
							"name": "Mets inn",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Asakusa View Hotel",
							"logoUrl": "http://gora.golf.rakuten.co.jp/img/rc-h-logo.gif",
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						},
						{
							"name": "Hilton Hotel Kyobashi",
							"review": 3.92,
							"rate": 4,
							"pageUrl": "/hotel/Japan-Tokyo_Prefecture-Tokyo-Shinagawa_Prince_Hotel/19455/",
							"imageUrl": "https://media-cdn.tripadvisor.com/media/photo-s/02/6f/c5/c7/hotel-exterior.jpg"
						}
					]
				}
			]
		}
	},
	"*/v*/*/seo?type=top": {
		"GET": {
			"title": "Rakuten Travel - Get the best deals on Japanese Hotels and Ryokans",
			"descriptions": "Japan's largest online travel site with over 20,000 Japanese Hotels and Ryokans. Find cheap, exclusive travel deals only on Rakuten Travel.",
			"canonical": "http://travel.rakuten.com/",
			"keywords": "Japan,hotels,Ryokan,inn,reserve,budget",
			"hreflangs": [
				{
					"href": "http://travel.rakuten.co.kr/",
					"hreflang": "ko"
				},
				{
					"href": "http://travel.rakuten.com.tw/",
					"hreflang": "zh-tw"
				},
				{
					"href": "http://travel.rakuten.com.hk/",
					"hreflang": "zh-hk"
				},
				{
					"href": "http://travel.rakuten.cn/",
					"hreflang": "zh-cn"
				},
				{
					"href": "http://travel.rakuten.co.th/",
					"hreflang": "th"
				},
				{
					"href": "http://travel.rakuten.com.sg/",
					"hreflang": "en-sg"
				},
				{
					"href": "http://travel.rakuten.com.my/",
					"hreflang": "en-my"
				},
				{
					"href": "http://travel.rakuten.fr/",
					"hreflang": "fr"
				},
				{
					"href": "http://travel.rakuten.co.id/",
					"hreflang": "id"
				},
				{
					"href": "http://travel.rakuten.co.jp/",
					"hreflang": "ja"
				}
			]
		}
	},
	"*/v*/*/signatures/*": {
		"GET": {
			"offset": 0,
			"limit": 10,
			"total": 6,
			"items": [
				{
					"title": "Awesome Japan.",
					"description": "",
					"imageWideUrl": "https://www.roughguides.com/wp-content/uploads/2012/09/130963804-1680x1050.jpg",
					"imageNarrowUrl": "http://img.travel.rakuten.com/hogehe/images/signature_s.png"
				},
				{
					"title": "ホノルル(オアフ島)",
					"description": "豊富な自然と多くの観光スポットが集まるハワイ島観光の中心、集いの島",
					"imageWideUrl": "//trvimg.r10s.jp/share/kaigai/images/area-hawaii/1.jpg",
					"imageNarrowUrl": ""
				},
				{
					"title": "マウイ島",
					"description": "白砂のビーチと自然、洗練されたリゾートを同時に楽しめる魔法の島",
					"imageWideUrl": "//trvimg.r10s.jp/share/kaigai/images/area-hawaii/2.jpg",
					"imageNarrowUrl": ""
				},
				{
					"title": "ハワイ島",
					"description": "熱帯雨林から雪山、活火山まで迫力ある地形が魅力の冒険の島",
					"imageWideUrl": "//trvimg.r10s.jp/share/kaigai/images/area-hawaii/3.jpg",
					"imageNarrowUrl": ""
				},
				{
					"title": "カウアイ島",
					"description": "数々の映画の舞台となった息を呑むほどに美しい自然が広がる庭園の島",
					"imageWideUrl": "//trvimg.r10s.jp/share/kaigai/images/area-hawaii/4.jpg",
					"imageNarrowUrl": ""
				},
				{
					"title": "ラナイ島",
					"description": "手付かずの大自然と豪華リゾートが共存する、静けさに包まれた最後の楽園",
					"imageWideUrl": "//trvimg.r10s.jp/share/kaigai/images/area-hawaii/5.jpg",
					"imageNarrowUrl": ""
				}
			]
		}
	},
	"*/v*/*/sites": {
		"GET": {
			"items": [
				{
					"id": "1",
					"lang": {
						"code": "ja_JP",
						"name": "日本"
					},
					"suffix": "icon-jp",
					"domainUrl": "http://travel.rakuten.co.jp"
				},
				{
					"id": "2",
					"lang": {
						"code": "en_US",
						"name": "English"
					},
					"suffix": "icon-us",
					"domainUrl": "http://travel.rakuten.com"
				},
				{
					"id": "3",
					"lang": {
						"code": "ko_KR",
						"name": "대한민국"
					},
					"suffix": "icon-kr",
					"domainUrl": "http://travel.rakuten.co.kr"
				},
				{
					"id": "4",
					"lang": {
						"code": "zh_CN",
						"name": "简体中文"
					},
					"suffix": "icon-cn",
					"domainUrl": "http://travel.rakuten.cn"
				},
				{
					"id": "5",
					"lang": {
						"code": "zh_HK",
						"name": "繁体中文"
					},
					"suffix": "icon-hk",
					"domainUrl": "http://travel.rakuten.com.hk"
				},
				{
					"id": "6",
					"lang": {
						"code": "zh_TW",
						"name": "繁体中文"
					},
					"suffix": "icon-tw",
					"domainUrl": "http://travel.rakuten.com.tw"
				},
				{
					"id": "7",
					"lang": {
						"code": "th_TH",
						"name": "ประเทศไทย"
					},
					"suffix": "icon-th",
					"domainUrl": "http://travel.rakuten.co.th"
				},
				{
					"id": "8",
					"lang": {
						"code": "en_SG",
						"name": "Singapore (Eng)"
					},
					"suffix": "icon-sg",
					"domainUrl": "http://travel.rakuten.com.sg"
				},
				{
					"id": "9",
					"lang": {
						"code": "en_MY",
						"name": "Malaysia (Eng)"
					},
					"suffix": "icon-my",
					"domainUrl": "http://travel.rakuten.com.my"
				},
				{
					"id": "10",
					"lang": {
						"code": "fr_FR",
						"name": "FranÃ§ais"
					},
					"suffix": "icon-fr",
					"domainUrl": "http://travel.rakuten.fr"
				},
				{
					"id": "11",
					"lang": {
						"code": "in_ID",
						"name": "Bahasa Indonesia"
					},
					"suffix": "icon-id",
					"domainUrl": "http://travel.rakuten.co.id"
				}
			]
		}
	},
	"*/v*/*/topDestinations/*": {
		"GET": {
			"items": [
				{
					"title": "test1",
					"imageUrl": "http://www.japantimes.co.jp/wp-content/uploads/2014/07/Biwako-Dai-Hanabi-Taikai.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test2",
					"imageUrl": "https://d3ftecjsng6jy5.cloudfront.net/images/topic/1174/content/43b5f152c47330181a879ff56bff0d937f2ae84f_p.jpeg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test3",
					"imageUrl": "http://tabetainjya.com/img/1603/suisenfantacy.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test4",
					"imageUrl": "http://blogs.c.yimg.jp/res/blog-d8-8a/bravojohnny2010/folder/561347/54/16154054/img_3?1348502558",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test5",
					"imageUrl": "http://www.japantimes.co.jp/wp-content/uploads/2014/07/Biwako-Dai-Hanabi-Taikai.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test6",
					"imageUrl": "https://d3ftecjsng6jy5.cloudfront.net/images/topic/1174/content/43b5f152c47330181a879ff56bff0d937f2ae84f_p.jpeg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test7",
					"imageUrl": "http://tabetainjya.com/img/1603/suisenfantacy.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test8",
					"imageUrl": "http://blogs.c.yimg.jp/res/blog-d8-8a/bravojohnny2010/folder/561347/54/16154054/img_3?1348502558",
					"pageUrl": "/hotellist/Japan"
				}
			]
		}
	},
	"*/v*/*/features": {
		"GET": {
			"items": [
				{
					"title": "test1",
					"imageUrl": "http://www.japantimes.co.jp/wp-content/uploads/2014/07/Biwako-Dai-Hanabi-Taikai.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test2",
					"imageUrl": "https://d3ftecjsng6jy5.cloudfront.net/images/topic/1174/content/43b5f152c47330181a879ff56bff0d937f2ae84f_p.jpeg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test3",
					"imageUrl": "http://tabetainjya.com/img/1603/suisenfantacy.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test4",
					"imageUrl": "http://blogs.c.yimg.jp/res/blog-d8-8a/bravojohnny2010/folder/561347/54/16154054/img_3?1348502558",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test5",
					"imageUrl": "http://www.japantimes.co.jp/wp-content/uploads/2014/07/Biwako-Dai-Hanabi-Taikai.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test6",
					"imageUrl": "https://d3ftecjsng6jy5.cloudfront.net/images/topic/1174/content/43b5f152c47330181a879ff56bff0d937f2ae84f_p.jpeg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test7",
					"imageUrl": "http://tabetainjya.com/img/1603/suisenfantacy.jpg",
					"pageUrl": "/hotellist/Japan"
				},
				{
					"title": "test8",
					"imageUrl": "http://blogs.c.yimg.jp/res/blog-d8-8a/bravojohnny2010/folder/561347/54/16154054/img_3?1348502558",
					"pageUrl": "/hotellist/Japan"
				}
			]
		}
	},
	"https://grid.travel.rakuten.com.tw/member/memberUserName*": {
		"GET": "({\"username\":\"Taro\",\"successFlag\":\"true\"})"
	},
	"https://grid.travel.rakuten.com.tw/member/point*": {
		"GET": "({\"totalPoint\":\"100000.00\",\"successFlag\":\"true\"})"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/mocks/resources.json
// module id = 912
// module chunks = 0